import { Injectable, inject, signal } from '@angular/core';
import Clarity from '@microsoft/clarity';
import { PlatformService } from 'ngx-unificator/services';
import { filter, first, map, tap } from 'rxjs/operators';
import { HostRequestsInterceptor } from '../interceptors/host-requests.interceptor';
import { StaticContentService } from './static-content.service';
import { environment } from '../../../environments/environment';
import { UserService } from './user/user.service';
import { switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClarityService {

  private _platform = inject(PlatformService);
  private _static = inject(StaticContentService);
  private _hostInterceptor = inject(HostRequestsInterceptor);
  private _user = inject(UserService);

  private _isLoaded = signal(false);

  public initClarity(): void {
    if (!this._platform.isBrowser || this._isLoaded()) {
      return;
    }

    this._static.item({ slug: 'winthrone-clarity-id' }).pipe(
      filter(item => !!item?.length),
      first(),
      map(item => this._resolveProjectIdFromGroupList(item?.[0]?.Grouplist)),
      filter(id => !!id),
      tap((projectId: string) => {
        Clarity?.init(projectId);
        this._isLoaded.set(true);
      }),
      switchMap(() => this._user.auth$),
      filter(auth => !!auth),
      first(),
    ).subscribe(() => {
      this.identify(this._user.info?.id);
      this.setTag('PlayerID', this._user.info?.id);
    });
  }

  private _resolveProjectIdFromGroupList(groupList: Record<string, any> | null | undefined): string {
    if (!groupList) {
      return '';
    }

    const hostname = this._hostInterceptor.getDomainName().split('.')[1];

    return String(groupList[hostname]?.id || '').trim();
  }

  public identify(playerId: string): void {
    Clarity?.identify(
      playerId,
      undefined,
      undefined,
      playerId
    );
  }

  public setTag(key: string, value: string): void {
    Clarity?.setTag(key, value);
  }
}
